<!-- @migration-task Error while migrating Svelte code: This migration would change the name of a slot making the component unusable -->
<script lang="ts">
	import { createDialog, melt } from '@melt-ui/svelte';
	import { X } from 'lucide-svelte';

	let { triggerChildren, contentChildren, class: clazz = '' } = $props();

	const {
		elements: { trigger, overlay, content, close, portalled },
		states: { open }
	} = createDialog({
		role: 'alertdialog'
	});
</script>

<button use:melt={$trigger} aria-label="open-dialog" class={clazz}>
	{@render triggerChildren()}
</button>

<div use:melt={$portalled}>
	{#if $open}
		<div use:melt={$overlay} class="fixed inset-0 z-50 bg-black/50"></div>
		<div
			class="bg-white-pure fixed bottom-0 left-[50%] z-50 max-h-[85vh] w-screen
              max-w-screen-sm translate-x-[-50%] rounded-t-2xl px-8 pt-8 pb-16 shadow-lg md:top-[50%] md:bottom-auto
              md:translate-y-[-50%] md:rounded-b-2xl md:pb-8"
			use:melt={$content}
		>
			<button use:melt={$close} aria-label="Close" class="absolute top-2 right-2 hidden md:block">
				<X class="h-6 w-6" />
			</button>
			{@render contentChildren()}
			<footer class="absolute right-0 bottom-4 left-0 text-center md:hidden">
				<button class="text-gray-mid text-sm" use:melt={$close}>Close</button>
			</footer>
		</div>
	{/if}
</div>
